module.exports = __webpack_public_path__ + "media/images/icons/eye-f9617dac1495c64f94e113ed9efa4dd8.svg";